var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.864,
    height: 19.767,
    viewBox: "0 0 16.864 19.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.039 15.682a3.3 3.3 0 0 0-2.094.769l-4.928-3.427a3.112 3.112 0 0 0 0-1.274l4.928-3.427a3.281 3.281 0 1 0-1.2-2.526 3.006 3.006 0 0 0 .066.637L9.882 9.861a3.3 3.3 0 1 0 0 5.053l4.928 3.426a3.006 3.006 0 0 0-.066.637 3.3 3.3 0 1 0 3.3-3.3zm0-10.984a1.1 1.1 0 1 1-1.1 1.1 1.1 1.1 0 0 1 1.1-1.098zM7.787 13.485a1.1 1.1 0 1 1 1.1-1.1 1.1 1.1 0 0 1-1.1 1.1zm10.252 6.59a1.1 1.1 0 1 1 1.1-1.1 1.1 1.1 0 0 1-1.1 1.101z",
    transform: "translate(-4.471 -2.505)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.740a3e47.svg";
export { ForwardRef as ReactComponent };